import UmbracoBase from './UmbracoBase';

export default class Banner extends UmbracoBase {
	constructor(args) {
		// Inheriting form UmbracoBase
		super(args);

		this.componentName = 'banner';
		this.link = args.link || [];
		this.hideButton = args.hideButton;
		this.tagTitle = args.tagTitle;
		this.text = args.text;
		this.title = args.title;
		this.subTitle = args.subTitle;
		this.image = args.image;
		this.altText = args.altText;
		this.imageCation = args.imageCaption;
		this.contentBackgroundColor = args.contentBackgroundColor;
		this.alignContent = args.alignContent;
		this.buttonColor = args.buttonColor;

		if (this.alignContent == 0) {
			this.alignContent = 'justify-start';
		} else if (this.alignContent == 1) {
			this.alignContent = 'justify-center';
		} else {
			this.alignContent = 'justify-end';
		}

		this.textColor = args.textColor;
		// override text color
		if (this.overrideTextColor) {
			this.textColor.color = this.overrideTextColor;
		} else if (this.textColor.color) {
			this.textColor.color = '#' + this.textColor.color;
		} else {
			this.textColor.color = 'black';
		}

		if (this.buttonColor.color) {
			this.buttonColor.color = '#' + this.buttonColor.color;
		} else {
			this.buttonColor.color = this.textColor.color;
		}

		this.smallImage = args.smallImage;
		// Use desktop image if no mobile image is served
		if (this.smallImage && !this.smallImage.imageCrops) {
			this.smallImage = this.image;
		}

		this.backgroundColor = args.backgroundColor;
		this.overrideBackgroundColor = args.overrideBackgroundColor;

		// Override background color

		if (this.image.imageCrops) {
			this.backgroundColor = 'none';
		} else if (this.overrideBackgroundColor.color) {
			this.backgroundColor.color = this.overrideBackgroundColor;
		} else if (this.backgroundColor.color) {
			this.backgroundColor.color = '#' + this.backgroundColor.color;
		} else {
			this.backgroundColor.color = 'none';
		}

		this.contentBackgroundColor = args.contentBackgroundColor;
		if (this.overrideContentBackgroundColor) {
			this.contentBackgroundColor.color = this.overrideContentBackgroundColor.replace('#', '');
		} else if (this.contentBackgroundColor) {
			this.contentBackgroundColor.color = '#' + this.contentBackgroundColor.color;
		} else {
			this.contentBackgroundColor.color = 'none';
		}

		// Text position
		this.textAlign = args.textAlign;
		this._alignItems = this.textAlign ? this.textAlign.toLowerCase() : 'center';

		const _positionMobile = this.contentPositionMobile || '0';
		let _alignItemsMobile = 'center';

		switch (_positionMobile) {
			case '0':
				_alignItemsMobile = 'center';
				break;
			case '1':
				_alignItemsMobile = 'flex-start';
				break;
			case '2':
				_alignItemsMobile = 'flex-end';
				break;
		}

		this._alignItemsMobile = _alignItemsMobile;
	}
}
